import React, { useEffect, useState, useRef } from "react";
import PropTypes from 'prop-types'
import MoreWhiteIcon from "../../common/images-new/more-white-icon.svg";
import { useHistory } from "react-router-dom";
import { BgBlue, Card, MenuItemCard, MenuItemDiv } from "../../pages/Theme";


const CardBlue = ({ data, onEdit, onDelete, publicView, isView }) => {
    const history = useHistory()
    const [dropdown, setDropdown] = useState(false)

    const popupRef = useRef();
    
    useEffect(() => {
        if(publicView !== true){
            const handleClick = (e) => {
                if (!popupRef.current.contains(e.target)) {
                setDropdown(false)
                }
            }

            document.addEventListener('mousedown', handleClick, false);

            return function cleanup() {
                document.removeEventListener('mousedown', handleClick, false);
            };
        }
    });

    const toggleDropdown = () => {
        setDropdown(!dropdown)
    }

    return(
        <BgBlue className="flex flex-row mt-2 md:mt-4 pl-3 p-2 relative rounded-lg reflectionbackgroundColor">
            <div className="flex flex-col w-full">
                <p className="text-xl flex font-bold blackColor md:mb-0 w-full gap-1">{ data.name }</p>
                
            </div>
                {
                !publicView &&
                <div ref={popupRef} className="flex items-center" onClick={toggleDropdown}>
                    {isView == false ? "" : 
                    <img 
                        className="mx-2 lg:mr-5 absolute top-3 md:top-5 right-3 lg:right-5 cursor-pointer hover:opacity-80" 
                        src={MoreWhiteIcon} 
                        alt="icon"
                    />}
                    {dropdown && (
                        <MenuItemCard className="absolute bg-white right-0 w-24 md:w-32 lg:w-36 mt-6 p-3 rounded-md filter 
                            drop-shadow transform -translate-x-4 z-10 translate-y-12"
                        >
                            <li className="md:pb-2 pl-2">
                                <MenuItemDiv
                                    className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                    onClick={() => history.push(`present/${data.id}`)}
                                >
                                    <p className="text-sm ">Present</p> 
                                </MenuItemDiv>
                                <MenuItemDiv
                                    className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                    onClick={onEdit}
                                >
                                    <p className="text-sm ">Edit name</p> 
                                </MenuItemDiv>
                                { 
                                    (data.ident.length === 0) &&
                                    <MenuItemDiv
                                        className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
                                        onClick={onDelete}
                                    >
                                        <p className="text-sm ">Delete</p> 
                                    </MenuItemDiv>
                                }
                            </li>
                        </MenuItemCard>
                    )}

                </div>
                }
        </BgBlue>
    )
}

CardBlue.propTypes = {
    title: PropTypes.string,
}

export default CardBlue
// import React, { useEffect, useState, useRef } from "react";
// import PropTypes from 'prop-types'
// import MoreWhiteIcon from "../../common/images-new/more-white-icon.svg";
// import { useHistory } from "react-router-dom";
// import { BgBlue, Card, MenuItemCard, MenuItemDiv } from "../../pages/Theme";


// const CardBlue = ({ data, onEdit, onDelete, publicView, isView }) => {
//     const history = useHistory()
//     const [dropdown, setDropdown] = useState(false)

//     const popupRef = useRef();
    
//     useEffect(() => {
//         if(publicView !== true){
//             const handleClick = (e) => {
//                 if (!popupRef.current.contains(e.target)) {
//                 setDropdown(false)
//                 }
//             }

//             document.addEventListener('mousedown', handleClick, false);

//             return function cleanup() {
//                 document.removeEventListener('mousedown', handleClick, false);
//             };
//         }
//     });

//     const toggleDropdown = () => {
//         setDropdown(!dropdown)
//     }

//     return(
//         <BgBlue className="flex flex-row mt-2 md:mt-4 py-2 md:py-4 px-3 md:px-5 lg:px-10 relative rounded-lg">
//             <div className="flex flex-col lg:w-2/3">
//                 <p className="text-lg lg:text-2xl font-bold text-white mb-1">{ data.name }</p>
//             </div>
//                 {
//                 !publicView &&
//                 <div ref={popupRef} className="flex items-center" onClick={toggleDropdown}>
//                     {isView == false ? "" : 
//                     <img 
//                         className="mx-2 lg:mr-5 absolute top-3 md:top-5 right-3 lg:right-5 cursor-pointer hover:opacity-80" 
//                         src={MoreWhiteIcon} 
//                         alt="icon"
//                     />}
//                     {dropdown && (
//                         <MenuItemCard className="absolute bg-white right-0 w-24 md:w-32 lg:w-36 mt-6 p-3 rounded-md filter 
//                             drop-shadow transform -translate-x-4 z-10 translate-y-12"
//                         >
//                             <li className="md:pb-2 pl-2">
//                                 <MenuItemDiv
//                                     className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
//                                     onClick={() => history.push(`present/${data.id}`)}
//                                 >
//                                     <p className="text-sm ">Present</p>	
//                                 </MenuItemDiv>
//                                 <MenuItemDiv
//                                     className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
//                                     onClick={onEdit}
//                                 >
//                                     <p className="text-sm ">Edit name</p>	
//                                 </MenuItemDiv>
//                                 { 
//                                     (data.ident.length === 0) &&
//                                     <MenuItemDiv
//                                         className="flex items-center md:mt-2 hover:opacity-70 cursor-pointer"
//                                         onClick={onDelete}
//                                     >
//                                         <p className="text-sm ">Delete</p>	
//                                     </MenuItemDiv>
//                                 }
//                             </li>
//                         </MenuItemCard>
//                     )}

//                 </div>
//                 }
//         </BgBlue>
//     )
// }

// CardBlue.propTypes = {
//     title: PropTypes.string,
// }

// export default CardBlue